import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";


export const GraphContent = styled.div`
    width:100%;
    height:100%;
    margin-top: auto;
    
    canvas{
        margin-top: auto;
        width:100% !important;
        max-height: 360px;
    }
`;
//background: rgb(189,57,68);
//background: linear-gradient(90deg, rgba(189,57,68,1) 0%, rgba(250,80,94,1) 100%);